import { lazy, Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { SnackbarGlobal } from '@pu/mpp-ui/components/snackbar';
import { MaintenanceContainer } from 'containers/maintenance.container';
import ThemeContainer from 'containers/theme.container';
import { PersistGate } from 'redux-persist/integration/react';
import { InsiderProvider } from 'core/contexts/insider.context';
import { MonitoringProvider } from 'core/contexts/monitoring.context';
import { ScreenProvider } from 'core/contexts/screen.context';
import monitoringInstance from 'shared/utils/monitoring-provider.utils';
import store, { persistor } from '../core/store';
import msalPublicClientApplication, { CustomNavigationClient } from '../shared/utils/msal.utils';
import { RollbackInternalError } from './errors/rollback-internal-error';
import { MainRoutes } from './main.routes';

const LazyAnalytics = lazy(() => import('shared/components/analytics'));

const AppContent = () => {
  const navigate = useNavigate();
  const navigationClient = new CustomNavigationClient(navigate);
  msalPublicClientApplication.setNavigationClient(navigationClient);

  return (
    <MonitoringProvider provider={monitoringInstance}>
      <MsalProvider instance={msalPublicClientApplication}>
        <ReduxProvider store={store}>
          <MaintenanceContainer>
            <ThemeContainer>
              <PersistGate loading={null} persistor={persistor}>
                <ScreenProvider>
                  <InsiderProvider>
                    <MainRoutes />
                  </InsiderProvider>
                </ScreenProvider>
                <Suspense fallback={null}>
                  <LazyAnalytics />
                </Suspense>
              </PersistGate>
              {/* <WhatsappButton /> */}
              <SnackbarGlobal />
            </ThemeContainer>
          </MaintenanceContainer>
        </ReduxProvider>
      </MsalProvider>
    </MonitoringProvider>
  );
};

const App = () => (
  <ErrorBoundary FallbackComponent={RollbackInternalError}>
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  </ErrorBoundary>
);

export default App;
